// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import loginService from "./components/Services/login.service";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBy0aY8HkqZpJrIEW3zV-US2FrPLDsOpvM",
  authDomain: "gna-energy-e57b6.firebaseapp.com",
  projectId: "gna-energy-e57b6",
  storageBucket: "gna-energy-e57b6.appspot.com",
  messagingSenderId: "911371749297",
  appId: "1:911371749297:web:8089e69e80fd0fc03a5f90",
  measurementId: "G-Z75WXK6QJQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

const getTokenOnLogin = async() =>{
  const isTokenExists = localStorage.getItem('DEVISE_TOKEN');
  try {
    // const messagingResolve = await messaging
    const currentToken = await getToken(messaging, { vapidKey: 'BOLsSkaiQlufJ75KyH7JRdtiOQ50KCxNLqH9QS_dTOsJS9ta-Bx1YODEmkS-ssXle3N1WS7jlrm6uYsrAaMeFCY' })
    return getToken(messaging, { vapidKey: 'BOLsSkaiQlufJ75KyH7JRdtiOQ50KCxNLqH9QS_dTOsJS9ta-Bx1YODEmkS-ssXle3N1WS7jlrm6uYsrAaMeFCY' })
      .then((currentToken) => {
        if (currentToken) {
          // Track the token -> client mapping, by sending to backend server
          // show on the UI that permission is secured
          // self.addEventListener("message", (event) => {
          //   console.log(event);
          // });
         isTokenExists === null && loginService.sendFirebaseToken(currentToken).then((response) => {
            if (response?.data?.code === 200) {
              console.log('Token Has been sent successfully');
              localStorage.setItem("DEVISE_TOKEN",currentToken);
            }
          }).catch(err => console.log("Error Found while sending Token: ", err));
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      })
  }
  catch (err) {
    console.log('An error occurred while retrieving token. ', err);
  }
}
export const GetTokens = async () => {
  if (Notification.permission === "granted") {
    // Permission already granted
    getTokenOnLogin()
  } else {
    // Request permission
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        getTokenOnLogin();
        console.log("Notification permission granted.");
      } else {
        console.error("Notification permission denied.");
      }
    });
  }
  // catch error while creating client token
}
export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
      // Handle the message as needed
    })
  });